import { Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { ReactNode } from 'react';
import { useTheme } from '@src/theme';

interface ModalHeaderProps {
    title?: string;
    headerIcon?: ReactNode;
    onClose: () => void;
    className?: string;
}

export function ModalHeader({
    title,
    headerIcon,
    onClose,
    className = '',
}: ModalHeaderProps) {
    const { theme } = useTheme();
    return (
        <div
            className={`flex items-center justify-between pb-4 ${className}`}
            style={{
                borderBottomWidth: '1px',
                borderBottomColor: theme.semantic.border,
            }}
        >
            <div className="flex items-center gap-2 text-lg font-semibold">
                {headerIcon && <span className="text-xl">{headerIcon}</span>}
                {title && <span>{title}</span>}
            </div>
            <Button type="text" icon={<CloseOutlined />} onClick={onClose} />
        </div>
    );
}
